module.exports = __webpack_public_path__ + "static/img/COC2023-14.a65d422.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-14.png
// module id = 1xml
// module chunks = 0